<template>
	<el-descriptions title="用户信息">
	    <el-descriptions-item label="用户名">{{userinfo.username}}</el-descriptions-item>
	    <el-descriptions-item label="已绑定集团">{{userinfo.company}}</el-descriptions-item>
	</el-descriptions>
</template>

<script>
	export default{
		data() {
			return{
				
			}
		},
		props:[
			'userinfo'
		],
	}
</script>

<style>
</style>
